<template>
  <div class="app-container">
    <el-tabs v-model="activeName">
      <el-tab-pane label="日流量" name="first">
        <day-flow />
      </el-tab-pane>
      <el-tab-pane label="月流量" name="second">
        <month-flow />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import DayFlow from './flow/dayFlow.vue';
import MonthFlow from "./flow/monthFlow";
export default {
  components:{
    MonthFlow,
    DayFlow
  },
  data() {
    return {
      activeName: 'first'
    };
  },
  methods: {
    
  },
  mounted() {
    
  },
  created() {
    
  }
};
</script>





















